export default {
    setBookings(state, bookings) {
        state.bookings = bookings;
    },
    setActiveBooking(state, booking) {
        state.activeBooking = booking;
    },
    setManageBookingDialog(state, status) {
        state.manageBookingDialog = status;
    },
    setDeleteBookingDialog(state, status) {
        state.deleteBookingDialog = status;
    },
    resetActiveBooking(state) {
        state.activeBooking = getNewBooking();
    }
}

function getNewBooking() {
    return {
        startDate: new Date().toISOString().substr(0, 10),
        startTime: '08:30',
        total: 0.00,
        discountValue: null
    }
}
